if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.init();
    }

    disconnectedCallback() {
      this.optionNodes.forEach((button) =>
        button.removeEventListener("mouseenter", this.onMouseEnter.bind(this))
      );
    }

    init() {
      const productCard = this.closest(".product-card");
      this.mainImage = productCard
        ? productCard.querySelector(".product-card__image--main img")
        : null;
      this.optionNodes.forEach((button) =>
        button.addEventListener("mouseenter", this.onMouseEnter.bind(this))
      );

      this.selected = this.querySelector('a[aria-selected="true"]');

      this.getVariantData();
      // snippets/colour-siblings.liquid reuses this <color-swatch> tag to link
      // to sibling PRODUCTS rather than variants. It has no [data-value] nodes
      // and no adjacent JSON script, so there is nothing to wire up. Bail out
      // instead of throwing. (Fixed 2026-08-22: this threw 6x per homepage.)
      if (!this.variantData.length || !this.optionNodes.length) return;
      this.initOptionSwatches();
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        let variantImage;
        const { optionPosition, value: optionValue } = optNode.dataset;
        const variant = this.variantData.find(
          (v) =>
            v[`option${optionPosition}`] &&
            v[`option${optionPosition}`].toLowerCase() ===
              optionValue.toLowerCase()
        );
        if (variant) {
          variantImage = variant.featured_image
            ? variant.featured_image.src
            : "";
          optNode.href = `${optNode.href}?variant=${variant.id}`;
          if (variantImage) {
            optNode.setAttribute(
              "data-src",
              getSizedImageUrl(variantImage, "900x")
            );
            optNode.setAttribute("data-srcset", getSrcset(variantImage));
          }
        }
      });
    }

    onMouseEnter(e) {
      const { target } = e;
      this.selected && this.selected.removeAttribute("aria-selected");
      target.setAttribute("aria-selected", true);

      const { src, srcset } = target.dataset;
      if (this.mainImage && srcset) {
        this.mainImage.src = src;
        this.mainImage.srcset = srcset;
      }

      this.selected = target;
    }

    getVariantData() {
      if (this.variantData) return;
      // The native card swatch (snippets/product-card-swatch.liquid) emits a
      // <script type="application/json"> immediately after </color-swatch>.
      // Other renderers do not, so verify before parsing rather than assuming.
      const next = this.nextElementSibling;
      const isJson =
        next &&
        next.tagName === "SCRIPT" &&
        (next.type || "").includes("json");
      if (!isJson) {
        this.variantData = [];
        return;
      }
      try {
        const parsed = JSON.parse(next.textContent);
        this.variantData = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        this.variantData = [];
      }
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}
